import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export type AccordionItemData = {
  title: string;
  content: string[];
};
type AccordionProps = {
  items: AccordionItemData[];
  variant?: 'dark' | 'light';
};
export function Accordion({
  items,
  variant = 'dark'
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const baseId = useId();
  const isLight = variant === 'light';
  const containerClass = isLight ? 'border border-[#06172e]/15 bg-white shadow-sm' : 'border border-white/15 bg-[#0c2544] shadow-lg';
  const buttonClass = isLight ? 'text-[#06172e] hover:bg-[#06172e]/5 focus-visible:outline-[#06172e]' : 'text-white hover:bg-white/5 focus-visible:outline-[#f7c948]';
  const panelClass = isLight ? 'border-[#06172e]/10 bg-[#06172e]/[0.02]' : 'border-white/10 bg-[#06172e]/25';
  const itemClass = isLight ? 'border-[#06172e]/10 bg-white text-[#06172e]/80' : 'border-[#f7c948]/25 bg-[#f7c948]/10 text-white/85';
  return <div className="space-y-3" data-id="element-1">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `${baseId}-${index}`;
      return <article key={item.title} className={`overflow-hidden rounded-xl ${containerClass}`} data-id="element-2">
            <h3 data-id="element-3">
              <button type="button" className={`flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-3px] sm:px-5 ${buttonClass}`} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-4">
                <span className="text-sm font-black leading-snug tracking-wide sm:text-base" data-id="element-5">
                  {item.title}
                </span>
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-[#f7c948] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-6" />
              </button>
            </h3>
            {isOpen && <div id={panelId} className={`border-t px-4 py-4 sm:px-5 ${panelClass}`} data-id="element-7">
                <div className="space-y-2.5" data-id="element-8">
                  {item.content.map((line, contentIndex) => <p key={`${item.title}-${contentIndex}`} className={`rounded-lg border px-3 py-2.5 text-sm leading-relaxed ${itemClass}`} data-id="element-9">
                      {line}
                    </p>)}
                </div>
              </div>}
          </article>;
    })}
    </div>;
}